import React from "react";
import "./ComplaintFormContent.scss";

/** @import {ComplaintFormRadioButtonsProps} from './ComplaintFormTypes' */
function ComplaintFormRadioButtons(/** @type {ComplaintFormRadioButtonsProps} */{ id, label, checked, onChange }) {

    /** @param {React.ChangeEvent<HTMLTextAreaElement>} e */
    return (
        <div className="complaintForm_radio">
            <input
                type="radio"
                id={id}
                checked={checked}
                onChange={(e) => onChange(e.target.value)}
                className="complaintForm_radioInput"
            />
            <label htmlFor={id} className="complaintForm_label">
                {label}
            </label>
        </div>
    );
}

export default ComplaintFormRadioButtons;
